// @ts-nocheck
import { Column } from 'react-table';
import { useIntl } from 'react-intl';
import { NewsletterSubscriber } from '../../core/_models';
import { NewsletterActionsCell } from './NewsletterActionsCell';

const newsletterColumns: ReadonlyArray<Column<NewsletterSubscriber>> = [
  {
    Header: (props) => {
      const intl = useIntl();
      return (
        <th className='min-w-200px'>
          {intl.formatMessage({ id: 'NEWSLETTER.COLUMN_EMAIL' })}
        </th>
      );
    },
    accessor: 'email',
  },
  {
    Header: (props) => {
      const intl = useIntl();
      return (
        <th className='min-w-125px'>
          {intl.formatMessage({ id: 'NEWSLETTER.COLUMN_STATUS' })}
        </th>
      );
    },
    id: 'isSubscribed',
    Cell: ({ row }) => {
      const intl = useIntl();
      return (
        <span className={`badge ${row.original.isSubscribed ? 'badge-light-success' : 'badge-light-danger'}`}>
          {row.original.isSubscribed
            ? intl.formatMessage({ id: 'NEWSLETTER.STATUS_SUBSCRIBED' })
            : intl.formatMessage({ id: 'NEWSLETTER.STATUS_UNSUBSCRIBED' })}
        </span>
      );
    },
  },
  {
    Header: (props) => {
      const intl = useIntl();
      return (
        <th className='min-w-150px'>
          {intl.formatMessage({ id: 'NEWSLETTER.COLUMN_DATE' })}
        </th>
      );
    },
    id: 'createdAt',
    Cell: ({ row }) => (
      <span>
        {row.original.createdAt
          ? new Date(row.original.createdAt).toLocaleDateString('fr-FR')
          : '—'}
      </span>
    ),
  },
  {
    Header: () => <th className='text-end min-w-100px' />,
    id: 'actions',
    Cell: ({ row }) => (
      <NewsletterActionsCell
        email={row.original.email}
        isSubscribed={row.original.isSubscribed}
      />
    ),
  },
];

export { newsletterColumns };
